<template>
  <div class="">
    <div
      class="absolute top-0 left-0 flex w-full"
      style="transform: translateY(-22px)"
    >
      <div class="flex bg-grey-10 text-white items-center p-1 px-2 gap-1">
        <span class="flex flex-no-wrap gap-2 text-xs font-bold">
          <q-badge color="purple" style="border-radius: 50px">
            <q-icon name="calendar_today" color="whtie" size="8px" />
          </q-badge>
          {{ data.time.split(' ')[0] }}
        </span>
        <span class="flex flex-no-wrap gap-2 text-xs">
          <q-badge color="teal" style="border-radius: 50px">
            <q-icon name="schedule" color="white" size="9px" />
          </q-badge>
          {{ data.time.split(' ').at(-1) }}
        </span>
      </div>
    </div>
    <div class="row">
      <q-card
        flat
        v-if="data.input && data.input != '-'"
        class="flex flex-center px-3 py-2 bg-teal-2 text-cyan-10 font-bold text-center"
        :class="{
          inputOn: data.input.includes('ON') === true,
        }"
        style="
          width: 40px;
          margin-right: 5px;
          font-size: 8px;
          white-space: normal;
          filter: hue-rotate();
        "
      >
        {{ data.input }}
      </q-card>
      <q-card
        flat
        v-if="data.input2 && data.input2 != '-'"
        class="flex flex-center px-3 py-2 bg-teal-2 text-cyan-10 font-bold text-center"
        :class="{
          inputOn: data.input2.includes('ON') === true,
        }"
        style="
          width: 40px;
          margin-right: 5px;
          font-size: 8px;
          white-space: normal;
          filter: hue-rotate();
        "
      >
        {{ data.input2 }}
      </q-card>
      <q-card
        flat
        v-if="data.input3 && data.input3 != '-'"
        class="flex flex-center px-3 py-2 bg-teal-2 text-cyan-10 font-bold text-center"
        :class="{
          inputOn: data.input3.includes('ON') === true,
        }"
        style="
          width: 40px;
          font-size: 8px;
          white-space: normal;
          filter: hue-rotate();
        "
      >
        {{ data.input3 }}
      </q-card>
    </div>
    <q-card
      flat
      v-if="data.fuel != '-'"
      class="flex flex-no-wrap flex-center px-1 py-2 cursor-pointer bg-teal-2 text-cyan-10 font-bold"
      :class="getFuel(data.fuel).length > 1 ? 'flex-col gap-0' : 'gap-1'"
      style="width: 60px"
      @click="$emit('chart', ['fuel', data])"
    >
      <span
        style="font-size: 8px"
        v-for="(n, i) in getFuel(data.fuel)"
        :key="i"
        class="flex flex-no-wrap relative"
        :class="{
          'w-full justify-between': getFuel(data.fuel).length > 1,
        }"
      >
        <span v-if="getFuel(data.fuel).length == 1">
          {{ n[0] }}
        </span>
        <span
          v-else
          v-for="(t, i2) in n"
          :key="t"
          :class="[
            i2 == 1 ? `bg-${getStatusFromPercentage(t)} text-black` : '',
          ]"
          :style="{ width: `${i2 == 1 ? '30px' : void 0}` }"
        >
          <span class="pl-1">
            {{ t }}
          </span>
          <span v-if="i2 == 1"> % </span>
        </span>
        <span
          class="bg-grey-7 w-full absolute bottom-0 left-0"
          style="height: 1px"
          v-if="i != getFuel(data.fuel).length - 1"
        />
      </span>

      <q-knob
        v-if="getFuel(data.fuel).length == 1"
        readonly
        show-value
        font-size="8px"
        :value="getFuel(data.fuel)[0][1]"
        size="25px"
        :thickness="0.22"
        :color="getStatusFromPercentage(getFuel(data.fuel)[0][1])"
        track-color="grey-3"
      >
        {{ getFuel(data.fuel)[0][1] }}%
      </q-knob>
      <!-- <q-tooltip
        anchor="center right"
        self="center left"
        content-class="bg-primary"
      >
        View Daily Fuel Chart
      </q-tooltip> -->
      <!-- <q-inner-loading>
        <q-spinner size="20px" color="primary" />
      </q-inner-loading> -->
    </q-card>
    <!-- temperature -->

    <q-card
      flat
      v-if="data.temp != '-'"
      class="flex justify-between items-center flex-no-wrap gap-1 px-2 py-2 cursor-pointer bg-teal-2 text-cyan-10 font-bold"
      style="width: fit-content"
      @click="$emit('chart', ['temp', data])"
    >
      <q-icon name="thermostat" color="danger" />
      <div class="flex flex-col" style="font-size: 8px">
        <span v-for="(n, i) in data.temp.split(',')" :key="i">
          {{ n }}
        </span>
      </div>

      <!-- <q-tooltip
        anchor="center right"
        self="center left"
        content-class="bg-primary"
      >
        View Daily Temperature Chart
      </q-tooltip> -->
      <!-- <q-inner-loading>
        <q-spinner size="20px" color="primary" />
      </q-inner-loading> -->
    </q-card>

    <div
      class="flex flex-col text-black font-medium text-xs flex-center px-1"
      v-if="data.status == 'Moving'"
    >
      <div>Speed</div>
      <vs-divider class="bg-white p-0 m-0" />
      <div>{{ data.speed }}</div>
    </div>
    <div
      class="flex flex-col text-black font-medium text-xs flex-center px-1"
      v-if="data.status == 'Idling'"
    >
      <div>Idling</div>
      <vs-divider class="bg-white p-0 m-0" />
      <div>{{ data.idlingStatus }}</div>
    </div>
    <div class="flex-1 flex" />
    <div class="flex flex-col text-black font-medium text-xs flex-center px-1">
      <div>Mileage</div>
      <vs-divider class="bg-white p-0 m-0" />
      <div>{{ data.mileage }}</div>
    </div>
    <div
      class="flex flex-col text-black font-medium text-xs flex-center px-1 gap-1"
      style="width: 80px"
    >
      <!-- <vs-button
        style="height: 20px"
        size="small"
        class="px-3 py-1 flex flex-center w-full"
        color="danger"
      >
        Change Asset
      </vs-button> -->
      <vs-button
        style="height: 20px"
        size="small"
        class="px-3 py-1 flex flex-center w-full"
        @click="$emit('center', data.assetId)"
      >
        Center View
      </vs-button>
    </div>
  </div>
</template>
<!--
<script>
export default {
  props: {
    data: {},
  },
};
</script> -->

<script setup>
import { defineProps, watch } from 'vue';

const prop = defineProps({
  data: {},
});

function getFuel(string) {
  let arr = string.split('\n');
  let result = [];
  if (arr.length > 1) {
    let liter = arr[0].split(',');
    let val = getStringBetweenParentheses(arr[1]);

    liter.forEach((e, i) => {
      result.push([e.trim(), val[i]]);
    });
  } else {
    let v = arr[0].split(' ');
    result.push([v[0].trim(), getStringBetweenParentheses(v[1])[0]]);
  }
  return result;
}

function getStringBetweenParentheses(inputString) {
  // Use regular expression to extract numeric values
  const numericValues = inputString.match(/\d+/g);

  // Convert the extracted values to integers
  return numericValues.map((value) => parseInt(value, 10));
}
function getStatusFromPercentage(percentage) {
  if (percentage >= 0 && percentage <= 30) {
    return 'danger';
  } else if (percentage > 30 && percentage <= 70) {
    return 'warning';
  } else if (percentage > 70 && percentage <= 100) {
    return 'success';
  } else {
    return 'Invalid percentage';
  }
}
</script>

<style scoped>
@-webkit-keyframes inputOn {
  from {
    /* filter: invert(0); */
    filter: hue-rotate(0deg) saturate(1);
  }
  to {
    /* filter: invert(1); */

    filter: hue-rotate(-90deg) saturate(2);
  }
}
@-moz-keyframes inputOn {
  from {
    /* filter: invert(0); */
    filter: hue-rotate(0deg) saturate(1);
  }
  to {
    /* filter: invert(1); */

    filter: hue-rotate(-90deg) saturate(2);
  }
}
@-o-keyframes inputOn {
  from {
    /* filter: invert(0); */
    filter: hue-rotate(0deg) saturate(1);
  }
  to {
    /* filter: invert(1); */

    filter: hue-rotate(-90deg) saturate(2);
  }
}
@keyframes inputOn {
  from {
    /* filter: invert(0); */
    filter: hue-rotate(0deg) saturate(1);
  }
  to {
    /* filter: invert(1); */

    filter: hue-rotate(-90deg) saturate(2);
  }
}
.inputOn {
  -webkit-animation: inputOn 0.8s infinite alternate-reverse; /* Safari 4+ */
  -moz-animation: inputOn 0.8s infinite alternate-reverse; /* Fx 5+ */
  -o-animation: inputOn 0.8s infinite alternate-reverse; /* Opera 12+ */
  animation: inputOn 0.8s infinite alternate-reverse; /* IE 10+ */
}
</style>
